const FocusInput = {
  inserted: function(el) {
    el.focus();
  },
};

export default FocusInput;
